import { ListingLog, Note } from "../../../../Constants/Constants";
import CommonHeading from "../Common/CommonHeading";
import NotesForm from "./NotesForm";
import NotesList from "./NotesList";

const Notes = () => {
  return (
    <div className="notes-main">
      <CommonHeading title={Note} sunTitle={ListingLog} />
      <NotesForm />
      <NotesList />
    </div>
  );
};

export default Notes;
